// extracted by mini-css-extract-plugin
export default {"section":"BA-z","inSectionButton":"CA-z","addressCard":"DA-z","disabled":"EA-z","cautionBox":"FA-z","failureBox":"GA-z","fade-out":"HA-z","successBox":"IA-z"};